export default {
    not_found: {
        title: 'Not found',
        heading: 'Sorry, that page isn’t here.',
        content: 'We may have moved the page you’re looking for somewhere else.',
    },
    no_access: {
        title: 'No access',
        heading: 'No access',
        description: 'Looks like you don’t have access to this page.',
    },
    general_error: {
        title: 'Whoops, something isn’t right!',
        heading: 'Whoops, something isn’t right!',
        description:
            'An unexpected error occurred on our side. No worries, we have been notified about the problem and will take care of it as soon as possible.',
    },
    active_session: {
        heading: 'This browser is opened in an active MedMatch Network session.',
        content: 'Would you like to start new session or continue active session?',
        buttons: {
            new_session: 'New session',
            cancel: 'Cancel',
        },
    },
}
